import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../services/auth.service';
import {Router} from '@angular/router';

@Component({
    selector: 'core-login',
    templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {
    user = {
        username: '',
        password: ''
    };

    constructor(private authService: AuthService, private router: Router) {
    }

    ngOnInit() {
        if (this.authService.isAuthenticated()) {
            this.router.navigate(['/']);
        }
    }

    login() {
        if (this.user.username && this.user.password) {
            this.authService.login(this.user).then((result) => {
                if (result) {
                    this.router.navigate(['/']);
                }
            });
        }
    }

}
